import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const UploadedBillingCell = ({ claim }) => {
   const { t } = useTranslation();
  if (claim.status === "Rejected") {
    return (
      <td>
        <span style={{ color: "gray" }}>Claim Rejected</span>
      </td>
    );
  }

  if (claim.status === "Waiting for Admin Action") {
    return (
      <td>
        <span style={{ color: "gray" }}>{t("ViewAdmin")}</span>
      </td>
    );
  }

  return (
    <td>
      <a
        href={`https://api-dashboard.nordmann-inkasso.de/${claim?.document?.replace(/\\/g, "/")}`}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="d-flex align-items-center"
         style={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151", // neutral dark gray
          background: "#f9fafb", // light SaaS bg
          padding: "6px 12px",
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#f3f4f6";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#f9fafb";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
       {t("DownloadBilling")}
      </a>
    </td>
  );
};

export default UploadedBillingCell;
